import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const uploadPreviewToServer = createAsyncThunk('image/uploadPreview', async (param) => {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE}/upload-preview`, param);
    return response.data;
});

const initialState = {
    uploading: false,
    previewURL: ''
};

const imageUploadSlice = createSlice({
    name: 'image',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // eslint-disable-next-line no-unused-vars
        builder.addCase(uploadPreviewToServer.pending, (state) => {
            state.uploading = true;
            state.previewURL = '';
        });

        builder.addCase(uploadPreviewToServer.fulfilled, (state, action) => {
            state.uploading = false;
            state.previewURL = action.payload.preview;
        });
    }
});

const imageUploadReducer = imageUploadSlice.reducer;
export default imageUploadReducer;
